import React from "react";
import "./boxStyle.css";
import addImg from "@/assets/img/add.png";
import { assetUrl } from "@/utils/assetUrl";

export type CreateFolderProps = {
  requestForm?: () => void;
};

const CreateFolder = ({ requestForm }: CreateFolderProps) => {
  const handleAddFolder = (e: React.MouseEvent<HTMLDivElement>) => {
    e.preventDefault();
    requestForm?.();
  };

  return (
    <div className="col-auto box" onClick={handleAddFolder}>
      <img
        src={assetUrl(addImg)}
        alt="add folder"
      />
      <h4 className="text-center text-primary">ADD FOLDER</h4>
    </div>
  );
};

export default CreateFolder;
